import React, { ForwardRefExoticComponent, RefAttributes } from "react";
import { Button } from "./button";
import { ButtonProps } from "./button.types";

export type IconButtonSharedProps = Omit<ButtonProps, "mainIcon" | "startIcon" | "endIcon" | "width" | "labelAlign">;

export interface IconButtonProps extends IconButtonSharedProps {
  /**
   * Must be an <Icon* /> element.
   * Ideally it should not have any props of its own.
   * But if set then they will override any styling by the IconButton component
   * which may lead to unexpected and inconsistent results.
   */
  icon: JSX.Element;
}

/**
 * The `IconButton` component is intended to be used when space is limited and the intent of the button action is sufficiently clear with an icon alone. A label text, although not visible, is still required for A11y.
 */
export const IconButton: ForwardRefExoticComponent<IconButtonProps & RefAttributes<HTMLButtonElement>> =
  React.forwardRef(({ icon, loadingAnimation, label, ...restProps }, ref) => {
    return (
      <Button
        {...{ ref }}
        mainIcon={icon}
        loadingAnimation={loadingAnimation === "spinner" ? "spinner-only" : loadingAnimation}
        {...restProps}
        label={label}
        aria-label={label}
      />
    );
  });

/**
 * This is needed so that this name shows up correctly in React DevTools
 */
IconButton.displayName = "IconButton";
